import { apiClient } from "@/api/axios";
import type { ApiResponse } from "@/types/api";
import type { ApplicationRequest, ApplicationData, ApplicationItem, ApplicationVillageRequest } from "@/types/Application/application";
import type { ApplicationDetailRequest } from "@/types/Application/applicationdetail";
import type { ApplicationUpdateRequest } from "@/types/Application/applicationupdate";

/**Get pending application list */
export async function GetPendingList(payload: ApplicationRequest) {
  const { data } = await apiClient.post<ApiResponse<ApplicationData>>(
    "/api/v1/application/get_pending_list",
    payload,
  );

  if (!data.status) {
    throw new Error(data.message ?? "Pending application fetch failed");
  }

  return data;
}

/**Get application detail */
export async function GetApplicationDetail(payload: ApplicationDetailRequest) {
  const { data } = await apiClient.post<ApiResponse<ApplicationItem>>(
    "/api/v1/application/get_registration_detail",
    payload,
  );

  if (!data.status) {
    throw new Error(data.message ?? "Application detail fetch failed");
  }

  return data; 
}

/**Get application update */
export async function UpdateRegistrationDetail(payload: ApplicationUpdateRequest) {
  const { data } = await apiClient.post<ApiResponse<null>>(
    "/api/v1/application/update_registration_detail",
    payload,
  );

 if (!data.status) {
    if (data.messageCode === "IDENTITY_NO_ALREADY_EXISTS") {
      throw new Error("Nombor MyKad atau pasport sudah wujud");
    }

    throw new Error(data.message ?? "Gagal mengemaskini maklumat.");
  }

  return data;
}

/**Approve application */
export async function ApproveRegistration(payload: ApplicationDetailRequest) {
  const { data } = await apiClient.post<ApiResponse<null>>(
    "/api/v1/application/approve_registration",
    payload,
  );

  if (!data.status) {
    throw new Error(data.message ?? "Application approval failed");
  }

  return data;
}

/**Reject application */
export async function RejectRegistration(payload: ApplicationDetailRequest) {
  const { data } = await apiClient.post<ApiResponse<null>>(
    "/api/v1/application/reject_registration",
    payload,
  );

  if (!data.status) {
    throw new Error(data.message ?? "Application rejection failed");
  }

  return data;
}

/**Get all application list */
export async function GetAllList(payload: ApplicationRequest) {
  const { data } = await apiClient.post<ApiResponse<ApplicationData>>(
    "/api/v1/application/get_all_list",
    payload,
  );

  if (!data.status) {
    throw new Error(data.message ?? "All application fetch failed");
  }

  return data;
}

/**Get all application list */
export async function GetRejectedList(payload: ApplicationRequest) {
  const { data } = await apiClient.post<ApiResponse<ApplicationData>>(
    "/api/v1/application/get_rejected_list",
    payload,
  );

  if (!data.status) {
    throw new Error(data.message ?? "Rejected application fetch failed");
  }

  return data;
}

/**Get all application list */
export async function GetVillageList(payload: ApplicationVillageRequest) {
  const { data } = await apiClient.post<ApiResponse<ApplicationData>>(
    "/api/v1/application/get_village_list",
    payload,
  );

  if (!data.status) {
    throw new Error(data.message ?? "Village application fetch failed");
  }

  return data;
}

/**Delete application */
export async function DeleteRegistration(payload: ApplicationDetailRequest) {
  const { data } = await apiClient.post<ApiResponse<null>>(
    "/api/v1/application/delete_registration",
    payload,
  );

  if (!data.status) {
    throw new Error(data.message ?? "Application deletion failed");
  }

  return data;
}
